'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    UserStore = require('../stores/UserStore'),
    Rotator = require('../molecules/Rotator'),
    shallowEqual = require('react/lib/shallowEqual'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var UserNavHeader = React.createClass({
  mixins: [createStoreMixin(UserStore), PureRenderMixin],

  propTypes: {
    userId: PropTypes.number.isRequired,
    scrolledPastPublished: PropTypes.bool.isRequired,
    scrolledPastCurated: PropTypes.bool.isRequired,
    scrolledPastLiked: PropTypes.bool.isRequired
  },

  getStateFromStores(props) {
    var user = UserStore.get(props.userId);

    return {
      user: user
    };
  },

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  render() {
    if (!this.state.user) {
      return null;
    }

    var activeIndex;
    if (this.props.scrolledPastLiked) {
      activeIndex = 3;
    } else if (this.props.scrolledPastCurated) {
      activeIndex = 2;
    } else if (this.props.scrolledPastPublished) {
      activeIndex = 1;
    } else {
      activeIndex = 0;
    }

    return (
      <Rotator activeIndex={activeIndex}>
        <span />
        <span>Published Stamps</span>
        <span>Curated Collections</span>
        <span>Liked Stamps</span>
      </Rotator>
    );
  }
});

module.exports = UserNavHeader;



/** WEBPACK FOOTER **
 ** ./molecules/UserNavHeader.jsx
 **/